import { TRootState } from 'Redux/Reducers';

export const getEventParentCategoryCount = (state: TRootState) => state.eventParentCategory.maxCount;
